module.exports = __webpack_public_path__ + "static/media/arrow-down.b87ffe6a.svg";